"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryBrushLine", {
  enumerable: true,
  get: function () {
    return _victoryBrushLine.default;
  }
});

var _victoryBrushLine = _interopRequireDefault(require("./victory-brush-line"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-line/lib/index.js
// module id = 1851
// module chunks = 0